import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { IUserLogin } from '@/types/auth';

export enum UserRoles {
  VENDOR = 'vendor',
  VENDOR_ADMIN = 'vendor_admin',
  COMPANY = 'company',
  COMPANY_ADMIN = 'company_admin',
  COMPANY_DEPO = 'company_depo',
  ADMIN = 'admin',
  XDOCK = 'xdock',
  XDOCK_ADMIN = 'xdock_admin',
  OPERATION = 'operation',
  SUPERADMIN = 'superadmin',
  SUPPORT = 'support',
  SUPPLIER_USER = 'supplier_user',
  ACCOUNTING = 'accounting',
  SECURITY = 'security',
  DRIVERS = 'drivers',
  HUMAN_RESOURCES = 'human_resources',
  PURCHASING_ADMIN = 'purchasing_admin',
  SALES = 'sales'
}

type Store = {
  user: IUserLogin | null;
  setUserData: (user: IUserLogin | null) => void;
  groups: UserRoles[];
  setGroups: (groups: UserRoles[]) => void;
  abilities: unknown;
  setAbilities: (abilities: unknown) => void;
};

export const useAuthStore = create<Store>()(
  persist(
    (set) => ({
      user: null,
      setUserData: (user: IUserLogin | null) => {
        set({ user });
      },
      groups: [],
      setGroups: (groups: UserRoles[]) => {
        set({ groups });
      },
      abilities: null,
      setAbilities: (abilities: unknown) => {
        set({ abilities });
      }
    }),
    {
      name: 'auth-store'
    }
  )
);
